"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMutator = exports.SSOUserService = exports.UserService = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var notification_service_1 = require("../components/notification.toast/notification.service");
var i18n_1 = require("../i18n");
var index_1 = require("./index");
var USER_STORAGE_KEY = 'currentUser';
var UserService = /** @class */ (function () {
    function UserService() {
        this.__priority = 25;
        this.current = null;
        this.lastDepartmentId = null;
    }
    Object.defineProperty(UserService.prototype, "hasUser", {
        get: function () {
            return this.current !== null;
        },
        enumerable: false,
        configurable: true
    });
    UserService.prototype.isIkeAnalyst = function (currentJson) {
        return !!(currentJson === null || currentJson === void 0 ? void 0 : currentJson.email.endsWith('ikegps.com'));
    };
    UserService.prototype.hasFormPermission = function (formOption) {
        if (formOption === core_api_1.IkeFieldType.FILE_TOOL) {
            return index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        }
        if (formOption === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            return index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_FORM_VERTICAL_SEPARATION) ||
                index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        }
        return true;
    };
    UserService.prototype.setUser = function (user) {
        this.current = user;
        if (user.settings != null) {
            this.lastDepartmentId = user.settings.departmentId;
        }
        return this.current;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], UserService.prototype, "current", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserService.prototype, "lastDepartmentId", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserService.prototype, "hasUser", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserService.prototype, "setUser", null);
    return UserService;
}());
exports.UserService = UserService;
var SSOUserService = /** @class */ (function (_super) {
    tslib_1.__extends(SSOUserService, _super);
    function SSOUserService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SSOUserService.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!index_1.Services.SSO.isAuthenticated) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.refresh()];
                                case 1:
                                    _a.sent();
                                    resolve();
                                    return [3 /*break*/, 3];
                                case 2:
                                    // This reaction MAY be redundant as the login will never happen
                                    // within this page since we redirect to Auth0 for login, and redirect back
                                    // once login is complete.
                                    (0, mobx_1.reaction)(function () { return index_1.Services.SSO.user; }, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                        return tslib_1.__generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.refresh()];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    resolve();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SSOUserService.prototype.login = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.Services.SSO.login()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOUserService.prototype.logout = function () {
        return tslib_1.__awaiter(this, arguments, void 0, function (federated) {
            if (federated === void 0) { federated = false; }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.Services.SSO.logout(federated)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOUserService.prototype.reloadCurrentUser = function () {
        if (this.current != null) {
            this.load(this.current);
        }
    };
    SSOUserService.prototype.load = function (user) {
        if (index_1.Services.SSO.isAuthenticated) {
            this.rest = index_1.Services.Rest.rest.bind(index_1.Services.SSO.token);
            try {
                index_1.Services.Department.rest.updateBoundUser(this.rest);
            }
            catch (err) {
                index_1.Logger.error({ error: err }, 'Failed updating bound user');
                notification_service_1.NotificationService.errorAsString('Fail to load user.');
            }
        }
        this.setUser(user);
        return this.current;
    };
    /**
     * Check to see if the current user has changed
     */
    SSOUserService.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, user, token, _b, e_1, msg, userKey, profile;
            var _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!index_1.Services.SSO.isAuthenticated) return [3 /*break*/, 6];
                        index_1.Logger.info({
                            currentUser: this.current && this.current.username,
                            accessToken: index_1.Services.SSO.token
                        }, 'SSOUserProfile');
                        _a = index_1.Services.SSO, user = _a.user, token = _a.token;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        _b = this;
                        return [4 /*yield*/, index_1.Services.Rest.rest.authenticate(user.sub, token)];
                    case 2:
                        _b.rest = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        if (core_shared_1.IkeRequestError.isIkeRequestError(e_1) && core_shared_1.IkeRequestErrorChecker.isValidationFailed(e_1)) {
                            index_1.Logger.error(e_1.message);
                            msg = ((_c = e_1.errors[0]) === null || _c === void 0 ? void 0 : _c.message) || (0, i18n_1.Translate)(i18n_1.T.ERROR_GENERAL);
                            notification_service_1.NotificationService.errorAsString(msg);
                        }
                        else {
                            index_1.Services.Log.Logger.error(e_1);
                            index_1.Logger.error(i18n_1.T.ERROR_GENERAL);
                            notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
                        }
                        //we have failed to authenticate user and thrown some notifications
                        //Clear out set info, logout, go back to login page.
                        this.rest = null;
                        if (this.hasUser) {
                            userKey = index_1.Services.LocalStorage.storageKey(USER_STORAGE_KEY);
                            index_1.Services.LocalStorage.removeItem(userKey);
                        }
                        this.logout(true); //logout from SSO
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(this.rest && token)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.rest.User.me()];
                    case 5:
                        profile = _d.sent();
                        this.rest.me.init(profile);
                        this.setUser(profile);
                        _d.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SSOUserService.prototype, "isAuthenticated", {
        get: function () {
            return index_1.Services.SSO.isAuthenticated;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.action
    ], SSOUserService.prototype, "refresh", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SSOUserService.prototype, "isAuthenticated", null);
    return SSOUserService;
}(UserService));
exports.SSOUserService = SSOUserService;
var UserMutator = /** @class */ (function () {
    function UserMutator() {
    }
    UserMutator.createSSO = function (inviteToken, firstname, lastname) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_create_SSO', inviteToken, 1);
                        return [4 /*yield*/, index_1.Services.Rest.rest.User.create({ inviteToken: inviteToken, firstname: firstname, lastname: lastname })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserMutator.setUnits = function (units) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_setSettings.units', units, 1);
                        return [4 /*yield*/, index_1.Services.User.rest.User.Settings.change({ units: units })];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, index_1.Services.User.load(user)];
                }
            });
        });
    };
    UserMutator.setDateFormat = function (dateFormat) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_setSettings.dateFormat', dateFormat, 1);
                        return [4 /*yield*/, index_1.Services.User.rest.User.Settings.change({ dateFormat: dateFormat })];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, index_1.Services.User.load(user)];
                }
            });
        });
    };
    UserMutator.setDepartment = function (departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_setSettings.departmentId', departmentId, 1);
                        return [4 /*yield*/, index_1.Services.User.rest.User.Settings.change({ departmentId: departmentId })];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, index_1.Services.User.load(user)];
                }
            });
        });
    };
    UserMutator.requestPasswordReset = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_requestPasswordReset', email, 1);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, index_1.Services.Rest.rest.SSOUser.triggerResetPassword({ email: email })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        e_2 = _a.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return UserMutator;
}());
exports.UserMutator = UserMutator;
//# sourceMappingURL=user.service.js.map